export default "__VITE_ASSET__YZPGsh$E__$_?nuxt_component=async&nuxt_component_name=IUsdgColorLogoInstagramIcon__"